export default __webpack_public_path__ + "static/media/respiration-black.6d243d66.svg";